import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {
    UigCartNotesDialogComponent
} from '../components/uig-cart/uig-cart-notes/uig-cart-notes-dialog/uig-cart-notes-dialog.component';

export const uigCartNotesDialogLayoutConfig: LayoutConfig = {
    launch: {
        CART_NOTES: {
            inlineRoot: true,
            component: UigCartNotesDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};
